import { Paper } from '@material-ui/core'
import { styled } from 'opensolar-ui'

export const StyledPaper = styled(Paper, { name: 'StyledPaper' })({
  padding: 20,
  marginBottom: 20,
  marginTop: 20,
})

export const StyledField = styled('div', { name: 'StyledField' })({
  marginBottom: 0,
  marginTop: 0,
})

export const StyledDateInput = styled('div', { name: 'StyledDateInput' })({
  marginBottom: 0,
  '& .MuiInputBase-root': {
    paddingLeft: 0,
  },
})

export const StyledDateInputGridItem = styled('div', { name: 'StyledDateInputGridItem' })({
  marginTop: 10,
  paddingLeft: 0,
})

export const StyledTable = styled('div', { name: 'StyledTable' })({
  '& .MuiTableCell-root': {
    border: 'none',
    padding: 5,
  },
})

